enum ClientTypeEnum {
    PERSON = 'PERSON',
    ENTREPRENEUR = 'ENTREPRENEUR',
    LEGAL_ENTITY = 'LEGAL_ENTITY',
}

export default ClientTypeEnum;
